export const PHONE_REGEX = new RegExp(
  '^(\\+?[1-9]\\d{0,2})?[-.\\s]?(\\(?\\d{1,4}\\)?[-.\\s]?)?(\\d{1,4}[-.\\s]?){1,3}\\d{1,4}$',
)
